import type { FC, ReactNode } from 'react'

export type LegalBlock = {
    title: string
    paragraphs: string[]
    /** Optional anchor so other pages can link straight to this block. */
    id?: string
}

type LegalProps = {
    updatedOn: string
    blocks: LegalBlock[]
}

export const Legal: FC<LegalProps> = ({ updatedOn, blocks }): ReactNode => {
    return (
        <section className='legal-section padding-bottom'>
            <div className='w-layout-blockcontainer container w-container'>
                <div className='legal-area'>
                    <p className='legal-date' data-reveal>
                        {`Last updated: ${updatedOn}`}
                    </p>

                    {blocks.map((block) => (
                        <div key={block.title} id={block.id} className='single-legal-content' data-reveal>
                            <h2 className='legal-title'>
                                {block.title}
                            </h2>

                            {block.paragraphs.map((paragraph) => (
                                <p key={paragraph.slice(0, 40)}>
                                    {paragraph}
                                </p>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
